import styled from "styled-components";

export const StyledBackground = styled.div`
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    align-items: center;
    justify-content: center;
`;
